import React from 'react';

import InputErrorMessage from '@components/common/Formik/InputErrorMessage/InputErrorMessage';

type RadioGroupProps = {
    name: string;
    children: React.ReactNode;
    customClass?: string;
    hideErrors?: boolean;
};

const RadioGroup = ({ name, customClass, children, hideErrors }: RadioGroupProps) => {
    return (
        <>
            <div className={customClass || ''}>{children}</div>
            {!hideErrors && <InputErrorMessage name={name} messageCode={name} />}
        </>
    );
};

export default RadioGroup;
